import { ComponentProps, ComponentType, useEffect } from 'react'
import { notifyLoaded } from '@/polyfill/appNotify'

const withLoadedNotify = (WrappedComponent: ComponentType) => {
  return (props: ComponentProps<typeof WrappedComponent>) => {
    useEffect(() => {
      notifyLoaded()
    }, [])
    return <WrappedComponent {...props} />
  }
}

export default withLoadedNotify
